import { Injectable } from '@angular/core';
import {
  BookingGuestVerificationModel,
  BookingModel,
  BookingVerificationStatus,
  OtpChannel,
} from '@app/core/models';
import { LoggingService } from '@app/core/services/logging/logging.service';

import { createStore, setProps, withProps } from '@ngneat/elf';
import {
  deleteAllEntities,
  getActiveEntity,
  selectActiveEntity,
  selectAllEntities,
  selectEntity,
  setActiveId,
  upsertEntities,
  withActiveId,
  withEntities,
} from '@ngneat/elf-entities';
import { joinRequestResult } from '@ngneat/elf-requests';
import { Observable } from 'rxjs';

export interface BookingsProps {
  meta: {
    lastRefresh: Date | null;
  };
}

const store = createStore(
  { name: 'bookings' },
  withProps<BookingsProps>({
    meta: { lastRefresh: null },
  }),
  withEntities<BookingModel, '_id'>({ idKey: '_id' }),
  withActiveId(),
);

@Injectable({ providedIn: 'root' })
export class BookingRepository {
  constructor() {}

  bookings$ = store.pipe(selectAllEntities(), joinRequestResult(['bookings']));
  /* activeBooking$ = store.pipe(selectActiveEntity()); */
  activeBooking$: Observable<BookingModel | undefined> =
    store.pipe(selectActiveEntity());

  get activeBooking() {
    LoggingService.log('active booking from repository');
    return store.query(getActiveEntity());
  }

  setActiveBookingId(bookingId: string | null) {
    LoggingService.log('setting active booking id', bookingId);
    store.update(setActiveId(bookingId));
  }

  updateBookings(bookings: BookingModel[] | undefined | null) {
    if (!Array.isArray(bookings)) {
      LoggingService.log('updateBookings: bookings is not an array', bookings);
      return;
    }
    store.update(
      upsertEntities(bookings),
      setProps({ meta: { lastRefresh: new Date() } }),
    );
    /*const availableBookings = bookings.filter(booking => {
      const today = new Date();
      const daysToCompare = addDays(new Date(booking.end), 3);
      // add 3 days to the end date to account for the 3 day buffer in case of a guest book services after the end date
      return (
        daysToCompare >= today || booking.stayType === StayType.RESIDENTIAL
      );
    });

    LoggingService.log('availableBookings FROM REPOSITORY', availableBookings);
    LoggingService.log('all bookings FROM REPOSITORY', bookings);

    if (availableBookings && availableBookings.length) {
      LoggingService.log(
        'updating bookings FROM REPOSITORY',
        availableBookings,
      );
      store.update(
        upsertEntities(availableBookings), // Changed from bookings to availableBookings
        setProps({ meta: { lastRefresh: new Date() } }),
      );
    }*/
  }

  upsertBooking(booking: BookingModel) {
    LoggingService.log('upsertBooking', booking);
    if (booking) {
      store.update(upsertEntities([booking]));
    }
  }

  getActiveBooking(): BookingModel | undefined {
    return store.query(getActiveEntity());
  }
  getBookingById(bookingId: string): Observable<BookingModel | undefined> {
    return store.pipe(selectEntity(bookingId));
  }

  public clear(): void {
    store.update(deleteAllEntities());
    store.update(setProps({ meta: { lastRefresh: null } }));
  }

  getGuestVerificationPendingActiveFromBooking(
    booking: BookingModel,
    channel: OtpChannel,
    phoneId?: string,
    emailId?: string,
  ): BookingGuestVerificationModel | undefined {
    const guestVerification = booking?.guestVerifications?.find(
      (verification) =>
        verification.otpChannel === channel &&
        (!verification.phoneId ||
          (phoneId && verification.phoneId === phoneId)) &&
        (!verification.emailId ||
          (emailId && verification.emailId === emailId)) &&
        verification.status === BookingVerificationStatus.PENDING &&
        verification.expiresAt &&
        new Date(verification.expiresAt) > new Date(),
    );
    return guestVerification;
  }
}
